import { render, staticRenderFns } from "./ForgotUsername.html?vue&type=template&id=0d6f36b1&scoped=true&"
import script from "./ForgotUsername.vue?vue&type=script&lang=ts&"
export * from "./ForgotUsername.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotUsername.scss?vue&type=style&index=0&id=0d6f36b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6f36b1",
  null
  
)

export default component.exports